import { ComponentType } from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import { setupToken } from '../helpers/authTokenHelpers';
import { trackPage } from '../services/analyticsService';
import { ROUTES } from '../routes/urls';
interface PrivateRouteProps extends RouteProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: ComponentType<any>;
  role?: string;
}

const PrivateRoute = (props: PrivateRouteProps) => {
  trackPage({ visit_url: props?.location?.pathname || '' });
  const { component: Component, role, ...rest } = props;
  const token = setupToken();

  return (
    <Route
      {...rest}
      render={(renderProps: RouteComponentProps) => {
        if (token) {
          return <Component {...renderProps} />;
        }
        // set return url if not home page
        const search =
          rest?.location?.pathname !== '/' ? `?return-url=${encodeURIComponent(rest?.location?.pathname || '/')}` : '';
        return (
          <Redirect
            to={{
              pathname:ROUTES.LOGIN,
              search: search
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
